import api from "./api";

// ======================
// Blog
// ======================

export const moveBlogUp = (id) =>
  api.patch(`/blogs/${id}/move-up`);

export const moveBlogDown = (id) =>
  api.patch(`/blogs/${id}/move-down`);

export const getBlogs = () =>
  api.get("/blogs");

export const getBlogById = (id) =>
  api.get(`/blogs/${id}`);

export const createBlog = (data) =>
  api.post("/blogs", data);

export const updateBlog = (id, data) =>
  api.put(`/blogs/${id}`, data);

export const deleteBlog = (id) =>
  api.delete(`/blogs/${id}`);

export const fixBlogOrder = () =>
  api.patch("/blogs/fix-order");